import { useCallback } from 'react';
import { toast } from 'sonner';
import { getTotalRecords, getRows } from '@/utils'; //FetchHelpers
import userService from '@/services/setting/userService';

const toUserOptions = (rows) =>
  rows.map(user => ({
    label: `${user.first_name} ${user.last_name}`,
    value: user.id.toString(),
    id: user.id.toString(),
    email: user.email,
    original: user,
  }));


const useUserOptions = ({ defaultPageSize = 20 } = {}) => {
  const loadOptions = useCallback(
    async ({ search = '', page = 1, pageSize = defaultPageSize } = {}) => {
      try {
        const response = await userService.getAllUsers({
          page,
          pageSize,
          search,
        });

        const status =
          typeof response?.status === 'boolean' ? response.status : true;
        if (!status) return { options: [], hasMore: false };

        const rows = getRows(response);
        const options = toUserOptions(rows);

        const totalRecords = getTotalRecords(response);
        const hasMore =
          typeof totalRecords === 'number'
            ? page * pageSize < totalRecords
            : options.length === pageSize;

        return { options, hasMore };
      } catch (error) {
        console.error('Error', error);
        toast.error('Failed to fetch users.', {
          description: 'Please try again.',
        });
        return { options: [], hasMore: false };
      }
    },
    [defaultPageSize]
  );

  return loadOptions;
};

export { useUserOptions };